import type {PermissionsRecordType} from '../permissions';

export const tireInventoryPermissions = {
  readTireInventory: {
    resourceId: 'TIRE_ORDER',
    actionId: 'READ',
    scopes: [],
  },
  readTireWarehouse: {
    resourceId: 'TIRE_WAREHOUSE',
    actionId: 'READ',
    scopes: ['TIRE_WAREHOUSE'],
  },
  createTireOrder: {
    resourceId: 'TIRE_ORDER',
    actionId: 'CREATE',
    scopes: ['BRANCH', 'BRANCH_SPECIFIC'],
  },
  createTireSet: {
    resourceId: 'TIRE_SET',
    actionId: 'CREATE',
    scopes: ['BRANCH', 'BRANCH_SPECIFIC', 'TIRE_ORDER_AUTHORIZATION_PROFILE'],
  },
  editTireSet: {
    resourceId: 'TIRE_SET',
    actionId: 'EDIT',
    scopes: ['BRANCH', 'BRANCH_SPECIFIC', 'TIRE_ORDER_AUTHORIZATION_PROFILE'],
  },
  receiveTireSet: {
    resourceId: 'TIRE_SET',
    actionId: 'RECEIVE',
    scopes: ['BRANCH', 'BRANCH_SPECIFIC', 'TIRE_ORDER_AUTHORIZATION_PROFILE'],
  },
  issueTireSet: {
    resourceId: 'TIRE_SET',
    actionId: 'ISSUE',
    scopes: ['BRANCH', 'BRANCH_SPECIFIC', 'TIRE_ORDER_AUTHORIZATION_PROFILE'],
  },
  archiveTireSet: {
    resourceId: 'TIRE_SET',
    actionId: 'ARCHIVE',
    scopes: ['BRANCH', 'BRANCH_SPECIFIC', 'TIRE_ORDER_AUTHORIZATION_PROFILE'],
  },
} satisfies PermissionsRecordType;
